import {
  DocumentSnapshot,
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase/firebase";
import { Collections } from "../utils/collections";
import { Speaker } from "@/models/speaker";

const speakerMap = (doc: DocumentSnapshot): Speaker => {
  const data = doc.data() as Speaker;
  if (!data.imagePath) {
    const path = data.image.split("/").pop();
    data.imagePath = decodeURIComponent(
      path?.substring(0, path.indexOf("?")) ?? ""
    );
  }
  data.id = doc.id;
  data.events = data.events ?? [];
  return data;
};

export async function getSpeakers(): Promise<Speaker[]> {
  const categorySnapshot = await getDocs(
    query(collection(db, Collections.SPEAKERS), orderBy("timestamp", "desc"))
  );
  let data = categorySnapshot.docs.map(speakerMap);
  return data as Speaker[];
}

export async function getFeaturedSpeakers(): Promise<Speaker[]> {
  const categorySnapshot = await getDocs(
    query(
      collection(db, Collections.SPEAKERS),
      where("featureOnHomePage", "==", true),
      orderBy("timestamp", "desc")
    )
  );
  let data = categorySnapshot.docs.map(speakerMap);
  return data as Speaker[];
}

export async function addUpdateSpeaker(speaker: Speaker) {
  try {
    return !speaker.id
      ? await addSpeaker(speaker)
      : await updateSpeaker(speaker);
  } catch (e) {
    return undefined;
  }
}

async function updateSpeaker(speaker: Speaker) {
  const eventRef = doc(db, Collections.SPEAKERS, speaker.id ?? "");
  const { id, ...rest } = speaker;
  await updateDoc(eventRef, { ...rest });
  const updatedSpeaker = await getDoc(eventRef);
  return speakerMap(updatedSpeaker);
}

async function addSpeaker(speaker: Speaker) {
  const eventRef = collection(db, Collections.SPEAKERS);
  const { id, ...rest } = speaker;
  const response = await addDoc(eventRef, { ...rest });
  const addedSpeaker = await getDoc(response);
  return speakerMap(addedSpeaker);
}
